export class MessengerDisconnectModalController {
    static $inject = ['close', 'page', 'button', 'disconnectPage', '$timeout', 'backButtonCallback'];
    constructor(close, page, button, disconnectPage, $timeout, backButtonCallback) {
        'ngInject';
        this.close = close;
        this.page = page;
        this.button = button;
        this.disconnectPage = disconnectPage;
        this.$timeout = $timeout;
        this.backButtonCallback = backButtonCallback;
        this.closeModal = () => {
            this.close();
            this.postCloseModalCallback();
        };
        this.postCloseModalCallback = () => {
            if (this.backButtonCallback && !this.confirmedDisconnection) {
                this.backButtonCallback(this.page);
            }
        };
        this.setDisconnectButtonDisabledStatus = () => {
            this.$timeout(() => {
                this.disconnectButtonDisabled = !this.agreedChecked || !this.motiveInputValue;
            });
        };
        this.motiveInputChange = (event) => {
            this.motiveInputValue = event.detail.value;
            this.setDisconnectButtonDisabledStatus();
        };
        this.agreedCheckChange = (event) => {
            this.agreedChecked = event.detail.checked;
            this.setDisconnectButtonDisabledStatus();
        };
        this.onConfirmDisconnect = async () => {
            if (this.disconnectPage && this.page && !this.disconnectButtonDisabled && this.button) {
                this.confirmedDisconnection = true;
                this.close();
                await this.disconnectPage(this.page, this.motiveInputValue, this.button);
            }
        };
        this.onModalChanged = (event) => {
            if (event.detail.modalStatus === 'closed') {
                this.close();
                this.postCloseModalCallback();
            }
        };
        this.motiveInputValue = '';
        this.agreedChecked = false;
        this.disconnectButtonDisabled = true;
        this.confirmedDisconnection = false;
    }
    $onInit() {
        document
            .getElementById('disconnect-agreed')
            .addEventListener('bdsChange', this.agreedCheckChange);
        document
            .getElementById('disconnect-motive-input')
            .addEventListener('bdsChange', this.motiveInputChange);
        document
            .getElementById('messenger-disconnect-modal')
            .addEventListener('bdsModalChanged', this.onModalChanged);
    }
}
MessengerDisconnectModalController.$inject = ['close', 'page', 'button', 'disconnectPage', '$timeout', 'backButtonCallback'];
